import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from 'react-router-dom';
import { Button, Box, Card, CardContent, FormHelperText, Grid, Typography, TextField, IconButton, InputLabel ,Select
    ,MenuItem,FormControl,
} from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import PhotoCamera from '@mui/icons-material/PhotoCamera';

const ConferenceBadge = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const [disabled, setDisabled] = useState(false);
    const [conferenceBadgeImage, setConferenceBadgeImage] = useState("");
    const [conferenceRecieptImage, setConferenceRecieptImage] = useState("");
    const [eventOptionsSetup, setEventOptionsSetup] = useState({
        conferenceBadgeImage: "",
        conferenceRecieptImage: "",
        participant_register_status: "",
        error_list: [],
    });
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });

    const fileInputRef = useRef(null);

    useEffect(() => {
        axios.get(`api/index-option-setup?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getOptionsData = res.data.getOptions;
                setEventOptionsSetup(getOptionsData);
            }
        });
    }, [eventid]);

    useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        });
    }, [eventid]);

    const handleBannerChange = (e) => {
        setConferenceBadgeImage(e.target.files[0]);
    };
        const handleRecieptChange = (e) => {
        setConferenceRecieptImage(e.target.files[0]);
    };

   const handleParticpantsRegisterActionChange = (e) => {
        setEventOptionsSetup({ ...eventOptionsSetup, [e.target.name]: e.target.value }); 
    }

    const optionSubmit = (e) => {
        e.preventDefault();
        const data = {
            eventid,
            conferenceBadgeImage,
            conferenceRecieptImage,
            participant_register_status: eventOptionsSetup.participant_register_status,
        };
        console.log(data);

        setDisabled(true);
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/add-option-setup`, data, config).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                    // Refresh the options setup data after successful submission
                    axios.get(`api/index-option-setup?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const getOptionsData = res.data.getOptions;
                            setEventOptionsSetup(getOptionsData);
                        }
                    });
                    setDisabled(false);
                    setConferenceBadgeImage("");
                    // Clear the file input
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                } else {
                    setEventOptionsSetup({ ...eventOptionsSetup, error_list: res.data.validate_error });
                }
            });
        });
    };

    let backGroundButtonByEvent = eventid ? abstractHomeSetup.color_code_two : '#145348';

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }}>
                    <Button
                        sx={{
                            float: 'right',
                            marginTop: '2%',
                            backgroundColor: backGroundButtonByEvent,
                            ":hover": { color: "white" }
                        }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}
                    >
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }}>
                    <CardContent>
                        <Typography component="h1" variant="h5">
                            Conference Badge
                        </Typography>
                        <Box component="form" onSubmit={optionSubmit} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="participants-email-action-select">Conference participants Auto Verify / Manual Verify</InputLabel>
                                    <Select
                                        labelId="participants-email-action-select"
                                        id="participants-email-action-select"
                                        label="Conference participants Auto Verify / Manual Verify"
                                        name="participant_register_status"
                                        value={eventOptionsSetup?.participant_register_status ?? "1"} // Use nullish coalescing instead of "||"
                                        onChange={handleParticpantsRegisterActionChange}
                                    >
                                        <MenuItem value={1}>Auto Verify</MenuItem>
                                        <MenuItem value={0}>Manual Verify</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                                <Grid item xs={6}>
                                    <label htmlFor="banner-upload">
                                        <TextField
                                            id="icon-button-file"
                                            type="file"
                                            onChange={handleBannerChange}
                                            name="[licenseFile]"
                                            inputRef={fileInputRef}
                                        />
                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => document.getElementById('banner-upload').click()}>
                                            <PhotoCamera />
                                        </IconButton>
                                        Upload Conference Badge
                                    </label>
                                    <FormHelperText>
                                        {eventOptionsSetup.error_list?.conference_badge
                                            ? `${eventOptionsSetup.error_list?.conference_badge} width=1920, height=1160`
                                            : ""}
                                    </FormHelperText>
                                    <div>
                                        {eventOptionsSetup?.conference_badge !== "no_image.jpg" && eventOptionsSetup?.conference_badge && (
                                            <img src={eventOptionsSetup?.conference_badge} width="300" height="400" alt="Conference Badge" />
                                        )}
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <label htmlFor="banner-upload">
                                        <TextField
                                            id="icon-button-file"
                                            type="file"
                                            onChange={handleRecieptChange}
                                            name="[licenseFile]"
                                            inputRef={fileInputRef}
                                        />
                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => document.getElementById('banner-upload').click()}>
                                            <PhotoCamera />
                                        </IconButton>
                                        Upload Conference Reciept 
                                    </label>
                                    <FormHelperText>
                                        {eventOptionsSetup.error_list?.conference_reciept
                                            ? `${eventOptionsSetup.error_list?.conference_reciept} width=1920, height=1160`
                                            : ""}
                                    </FormHelperText>
                                    <div>
                                        {eventOptionsSetup?.conference_reciept !== "no_image.jpg" && eventOptionsSetup?.conference_reciept && (
                                            <img src={eventOptionsSetup?.conference_reciept} width="100%" height="auto" alt="Conference Badge" />
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                          
                            <Grid container justifyContent="flex-end">
                                <Button
                                    disabled={disabled}
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
};

export default ConferenceBadge;
